<h2>User Details
  @if (selectedStore) {
    <a routerLink="/stores/{{selectedStore.slug}}" class="btn btn-light btn-sm">
      < Back to {{ selectedStore.name }}
    </a>
  }
</h2>
@if (userDetails) {
  <div>
    <p>User: {{ userDetails.email }}</p>
    <p>Assigned stores: {{ getUserStoresNames() }}</p>
    <p>Assigned groups: {{ userDetails.groups.join(', ') }}</p>
    @if (hasAccessToAssignStores()) {
      <td>
        <a (click)="assignStores()" class="btn btn-primary btn-sm pointer text-white">Assign stores</a>
      </td>
    }
  </div>
}